<template>
  <div class="login_warp">
    <el-dialog
        title=""
        width="860px"
        top="0"
        :visible.sync="showLogin"
        :before-close="closeFun"
        :append-to-body="true"
        :show-close="false"
        :close-on-click-modal="false"
        @open="openFun"
        :lock-scroll="true">
      <div class="login_box">
        <div class="left">
          <img class="login_bg" src="../../assets/image/login_bg.png" alt="">
        </div>
        <div class="right register">
          <div class="kind_img account_login cspt" v-if="selectId==2" @click="selectMod(0)">
            <img class="kind_text" src="../../assets/image/pc_text.png" alt="">
          </div>

          <div class="kind_img ewm_login cspt" v-if="selectId==0||selectId==1" @click="selectMod(2)">
            <img class="kind_text" src="../../assets/image/ewm_text.png" alt="">
          </div>

          <div class="ewm_box" v-if="selectId==2">
            <wxlogin
                appid="wx7f9e6c92f36678f7"
                scope="snsapi_login"
                redirect_uri="http://www.zaixinli.com/wxpclogin"
                :href="href"
                state="PC">
            </wxlogin>

            <!--            <div class="ewm_title">微信扫码登录</div>-->

            <!--            <div class="ewm_img_box">-->
            <!--              <img class="ewm_img" src="../../assets/image/ewm.png" alt="">-->
            <!--            </div>-->

            <!--            <div class="ewm_title">微信扫码登录</div>-->

            <!--            <div class="ewm_img_box">-->
            <!--              <img class="ewm_img" src="../../assets/image/ewm.png" alt="">-->
            <!--            </div>-->
          </div>

          <div class="register_box" v-if="selectId==3||selectId==4">

            <div class="register_title">{{ selectId == 3 ? '注册账号' : '重置密码' }}</div>

            <div class="form_box">
              <el-form ref="form" :model="form" :rules="loginRules">
                <el-form-item label="">
                  <div class="form_item_box">
                    <div class="item_pre">手机号：</div>
                    <el-input v-model="form.phonenumber"></el-input>
                  </div>
                </el-form-item>

                <el-form-item label="">
                  <div class="form_item_box code_box">
                    <div class="item_pre">验证码：</div>
                    <el-input v-model="form.phonecoder"></el-input>
                    <div class="code_btn" @click="getPhoneCode()" v-if="isGetCode">获取验证码</div>
                    <div class="code_btn" v-if="!isGetCode">
                      <el-statistic :value="deadline" time-indices title="" :format="'ss'+'秒'"
                                    @finish="isGetCode=true"></el-statistic>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item label="">
                  <div class="form_item_box pass_box">
                    <div class="item_pre">密码：</div>
                    <el-input v-model="form.pwd" type="password"></el-input>
                  </div>
                </el-form-item>

                <el-form-item label="">
                  <div class="form_item_box pass_box pass_box_sec">
                    <div class="item_pre">确认密码：</div>
                    <el-input v-model="form.pwdc" type="password"></el-input>
                  </div>
                </el-form-item>
              </el-form>
            </div>

            <div class="login_btn_box" @click="registerForm()">
              <div class="login_text">{{ selectId == 3 ? '注册' : '确认提交' }}</div>
              <img class="login_img" v-if="selectId==3" src="../../assets/image/register_img.png" alt="">
            </div>

          </div>

          <div class="account_box" v-if="selectId==0||selectId==1">
            <div class="nav_box">
              <div class="nav_item cspt" :class="selectId==0?'active':''" @click="selectMod(0)">账号密码登录</div>
              <div class="nav_item cspt" :class="selectId==1?'active':''" @click="selectMod(1)">手机号登录</div>
            </div>

            <div class="form_box" v-if="selectId==1">
              <el-form ref="form" :model="form" :rules="loginRules">
                <el-form-item label="">
                  <div class="form_item_box">
                    <div class="item_pre">手机号：</div>
                    <el-input v-model="form.phonenumber"></el-input>
                  </div>
                </el-form-item>

                <el-form-item label="">
                  <div class="form_item_box code_box">
                    <div class="item_pre">验证码：</div>
                    <el-input v-model="form.phonecode"></el-input>
                    <!--                    <div class="code_btn" @click="getPhoneCode()">获取验证码</div>-->
                    <div class="code_btn" @click="getPhoneCode()" v-if="isGetCode">获取验证码</div>
                    <div class="code_btn" v-if="!isGetCode">
                      <el-statistic :value="deadline" time-indices title="" :format="'ss'+'秒'"
                                    @finish="isGetCode=true"></el-statistic>
                    </div>
                  </div>
                </el-form-item>
              </el-form>
            </div>

            <div class="form_box" v-if="selectId==0">
              <el-form ref="form" :model="form" :rules="loginRules">
                <el-form-item label="" prop="name" :inline-message="true">
                  <div class="form_item_box pass_box">
                    <div class="item_pre">账号：</div>
                    <el-input v-model="form.name"></el-input>
                  </div>
                </el-form-item>

                <el-form-item label="" prop="passwd" :inline-message="true">
                  <div class="form_item_box pass_box">
                    <div class="item_pre">密码：</div>
                    <el-input type="password" v-model="form.passwd"></el-input>
                  </div>
                </el-form-item>

                <el-form-item label="" prop="vercode" :inline-message="true">
                  <div class="form_item_box code_box">
                    <div class="item_pre">验证码：</div>
                    <el-input v-model="form.vercode"></el-input>
                    <div class="code_btn">
                      <img class="login_img" @click="getvercode()" :src="vercodesrc" alt="">
                    </div>
                  </div>
                </el-form-item>
              </el-form>
            </div>

            <div class="loginText_box" v-if="selectId==0">
              <div class="forgot_btn cspt" @click="selectMod(4)">忘记密码？</div>
              <div class="no_account">没有账号？<span class="register_btn cspt" @click="selectMod(3)">去注册</span></div>
            </div>

            <div class="login_btn_box cspt" v-if="selectId==0" @click="loginForm()">
              <div v-if="!loading" class="login_text">登录</div>
              <div v-else class="login_text">登录中...</div>
              <img class="login_img" src="../../assets/image/login_img.png" alt="">
            </div>

            <div class="login_btn_box cspt" v-if="selectId==1" @click="phoneLoginForm()">
              <div v-if="!loading" class="login_text">登录</div>
              <div v-else class="login_text">登录中...</div>
              <img class="login_img" src="../../assets/image/login_img.png" alt="">
            </div>

          </div>
        </div>
      </div>

      <div @click="closeFun()" class="dialog_close el-icon-close cspt"></div>
    </el-dialog>
  </div>
</template>

<script>
import wxlogin from 'vue-wxlogin'
import {getCodeImg, login, resetpwd} from "@/api/login.js"
import {phoneLogin} from "@/api/login.js"
import {verifyPhone} from "@/api/login.js"
import {register} from "@/api/login.js"
import {Message} from "element-ui";
import {setItemWithExpiry, getItemWithExpiry} from "@/store/localstoragewithexpire";
import request from "@/utils/request";

export default {
  components: {wxlogin},
  props: {
    showLogin: Boolean,
    close: Function,
  },
  data() {
    return {
      deadline: 0,
      isGetCode: true,
      dialogVisible: false,
      form: {
        name: '',
        passwd: '',
        vercode: '',
        phonenumber: '',
        phonecode: '',
        phonecoder: '',
        pwd: '',
        pwdc: '',
        uuid: ''
      },
      loginRules: {
        name: [
          {required: true, trigger: "blur", message: "请输入您的账号"}
        ],
        passwd: [
          {required: true, trigger: "blur", message: "请输入您的密码"}
        ],
        vercode: [{required: true, trigger: "change", message: "请输入验证码"}]
      },
      selectId: 0,
      vercodesrc: '',
      loading: false,
    };
  },
  methods: {
    openFun() {
      this.getvercode();
    },
    selectMod(id_) {
      this.selectId = id_
    },
    closeFun() {
      this.selectId = 0
      this.close()
    },
    // 模拟请求方法--带参数
    getvercode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.vercodesrc = "data:image/gif;base64," + res.img;
          this.form.uuid = res.uuid;
        }
      });

    },
    loginForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          let data = {
            username: this.form.name,
            password: this.form.passwd,
            validateCode: this.form.vercode,
            rememberMe: false,
            uuid: this.form.uuid,
            front: true,
          }
          login(data).then(res => {
            if (res.code == 0) {
              // 存储登录状态
              sessionStorage.setItem("user", JSON.stringify(res.user))
              setItemWithExpiry("isLogin", 1);
              setItemWithExpiry("token", res.token);
              setItemWithExpiry("isPersonLogin", 1);
              setItemWithExpiry("iploginsucc", 0);
              window.location.reload();
            } else {
              Message({
                message: res.msg,
                type: 'error',
                duration: 2 * 1000
              })
              this.getvercode();
            }
            this.loading = false
          }).catch(error => {
            this.loading = false;
            this.getvercode();
            this.getvercode();
          });
        } else {
          return false;
        }
      })
    },

    phoneLoginForm() {
      let data = {
        phonenumber: this.form.phonenumber,
        phonecode: this.form.phonecode,
      }
      phoneLogin(data).then(res => {
        if (res.code == 0) {
          // localStorage.setItem("isLogin", 1);
          // localStorage.setItem("token", res.token);
          localStorage.setItem("isPersonLogin", 1);
          sessionStorage.setItem("user", JSON.stringify(res.user))
          setItemWithExpiry("isLogin", 1);
          setItemWithExpiry("isPersonLogin", 1);
          setItemWithExpiry("token", res.token);
          //setItemWithExpiry("user",JSON.stringify(res.user));
          window.location.reload();
        } else {
          Message({
            message: res.msg,
            type: 'error',
            duration: 2 * 1000
          })
        }
      }).catch(error => {
        console.log(error);
      });
    },

    getPhoneCode() {
      let data = {
        phonenumber: this.form.phonenumber,
        mtype: 'login'
      }
      verifyPhone(data).then(res => {
        if (res.code != 0) {
          Message({
            message: res.msg,
            type: 'error',
            duration: 2 * 1000
          })
          return
        } else {
          // 请求成功显示倒计时
          this.isGetCode = false;
          this.deadline = Date.now() + 60 * 1000;
        }
      })
    },

    registerForm() {
      let data = {
        phonenumber: this.form.phonenumber,
        phonecode: this.form.phonecoder,
        password: this.form.pwd,
        pwd: this.form.pwdc
      }
      if (this.selectId == 3) {
        register(data).then(res => {
          if (res.code == 0) {
            setItemWithExpiry("isLogin", 1);
            setItemWithExpiry("token", res.token);
            setItemWithExpiry("isPersonLogin", 1);
            //localStorage.setItem("isPersonLogin", 1);
            sessionStorage.setItem("user", JSON.stringify(res.user))
            window.location.reload();
          } else {
            Message({
              message: res.msg,
              type: 'error',
              duration: 2 * 1000
            })
          }
        }).catch(error => {
          console.log(error);
        });
      } else if (this.selectId == 4) {
        resetpwd(data).then(res => {
          if (res.code == 0) {
            Message({
              message: res.msg,
              type: 'success',
              duration: 2 * 1000
            })
            window.location.reload();
          } else {
            Message({
              message: res.msg,
              type: 'error',
              duration: 2 * 1000
            })
          }
        }).catch(error => {
          console.log(error);
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-statistic {
  height: 40px;

  .con {
    height: 40px;
  }

  .number {
    line-height: 40px;
    color: #fff;
  }
}

.dialog_close {
  position: absolute;
  top: -40px;
  right: 0;
  font-size: 28px;
  color: #ffffff;
}

::v-deep .el-dialog {
  background: transparent;
  box-shadow: none;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }
}

::v-deep .login_box {
  width: 860px;
  // height: 492px;
  background: #ff00ff;
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;

  .left {
    width: 504px;
    flex-shrink: 0;

    .login_bg {
      width: 100%;
      height: 100%;
    }
  }

  .right {
    // width: 356px;
    flex-grow: 1;
    background: #ffffff;
    position: relative;
    padding-top: 102px;
    box-sizing: border-box;

    .account_box, .register_box {
      padding: 0 36px;
      box-sizing: border-box;

      .register_title {
        font-size: 18px;
        color: #333333;
        font-weight: 700;
        text-align: center;
      }

      .nav_box {
        display: flex;
        padding: 0 16px;
        box-sizing: border-box;
        justify-content: space-between;

        .nav_item {
          width: 120px;
          height: 38px;
          color: #333333;
          font-size: 14px;
          text-align: center;
          line-height: 38px;
          border-radius: 19px;
        }

        .nav_item.active {
          background: #FF7F92;
          color: #ffffff;
        }
      }

      .form_box {
        margin-top: 22px;

        .el-form-item {
          margin-bottom: 10px;
        }

        .form_item_box {
          width: 100%;
          // height: 38px;
          border-radius: 19px;
          background: #F7F7F9;
          display: flex;
          align-items: center;
          position: relative;

          .el-input__inner {
            background: transparent;
            border: 1px solid #F7F7F9;
            border-radius: 20px;
            padding-left: 72px;
          }

          .el-input__inner:focus {
            border: 1px solid #FF7F92;
          }

          .code_btn {
            position: absolute;
            top: 0;
            right: 0;
            width: 102px;
            height: 40px;
            border-radius: 20px;
            background: #FF8093;
            font-size: 12px;
            color: #FFFFFF;
            text-align: center;
            cursor: pointer;
          }

          .item_pre {
            flex-shrink: 0;
            position: absolute;
            top: 0;
            left: 16px;
            z-index: 10;
            color: #8A8A8A;
          }
        }

        .code_box {
          .el-input__inner {
            padding-right: 102px;
          }

          .login_img {
            width: 100%;
            height: 100%;
            border-radius: 20px;
          }
        }

        .pass_box {
          .el-input__inner {
            padding-left: 58px;
          }
        }

        .pass_box_sec {
          .el-input__inner {
            padding-left: 88px;
          }
        }
      }

      .login_btn_box {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #FF8093;
        height: 40px;
        border-radius: 20px;
        margin-top: 50px;
        cursor: pointer;
        .login_text {
          font-size: 16px;
          color: #ffffff;
        }

        .login_img {
          width: 20px;
          height: 20px;
          border-radius: 20px;
        }
      }

      .loginText_box {
        display: flex;
        justify-content: space-between;
        padding: 0 16px;
        box-sizing: border-box;
        font-size: 12px;
        color: #FF8093;

        .no_account {
          color: #8A8A8A;
        }

        .register_btn {
          color: #FF8093;
        }
      }
    }

    .ewm_box {
      padding: 0 28px;

      .ewm_title {
        font-size: 18px;
        color: #333333;
        font-weight: 700;
        text-align: center;
      }

      .ewm_img_box {
        width: 234px;
        height: 234px;
        margin: 30px auto 0;
        padding: 7px;
        box-sizing: border-box;
        background: url("../../assets/image/ewm_img_bg.png") no-repeat center/100%;

        .ewm_img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
      }
    }

    .kind_img {
      position: absolute;
      top: 0;
      right: 0;
      width: 72px;
      height: 72px;

      &:hover {
        .kind_text {
          display: block;
        }
      }
    }

    .account_login {
      background: url("../../assets/image/pc_bg.png") no-repeat center/100%;
    }

    .ewm_login {
      background: url("../../assets/image/ewm_bg.png") no-repeat center/100%;
    }

    .kind_text {
      display: none;
      position: absolute;
      top: 26px;
      right: 78px;
      height: 24px;
    }
  }

  .right.register {
    padding-top: 84px;
  }
}
</style>